import { css } from '@emotion/react'
import { Typography, cssVar, ThemedColors } from '@opallabs/gem'

export const footer = css({
  ...Typography.T500,
  padding: '6px 8px',
  backgroundColor: cssVar(ThemedColors.Surface1),
  '&:hover': {
    cursor: 'pointer',
  },
})
